<template>
  <v-app class="page">
     <v-app-bar
      class="header box-header"
      app
      fixed
      dense
      elevation="0"
      color="white"
      height="64"
    >
      <v-icon  left style="margin-left:20px margin-right:20px" color="primary" class="icon-bars" onclick="mobileMenu()">fas fa-bars</v-icon>
      <v-toolbar-title>
        <b style="margin-left:20px">Perfil</b>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-card
              flat
               width="100%"
              elevation="15"
              class="full-height ml-2 mr-2 fill-width fill-height"
              :loading="status == 'loading'"
            >
              <v-toolbar flat>
                <v-toolbar-title>
                  <b style="font-size:26px; margin-left:20px">Editar Perfil</b>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <ValidationObserver ref="validator" v-slot="{}">
                  <v-form>
                    <v-row justify="center">
                      <v-col cols="6">
                        <v-row>
                          <v-col>
                            <ValidationProvider ref="name" rules="required"
                                                v-slot="{ errors }">
                              <v-text-field
                                :error-messages="errors"
                                v-model="user.name"
                                label="Nombre"
                                autocomplete="off"
                                readonly
                                onfocus="this.removeAttribute('readonly');"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>

                       <!--  <v-row>
                          <v-col>
                            <ValidationProvider ref="apodo" rules="required"
                                                v-slot="{ errors }">
                              <v-text-field
                                :error-messages="errors"
                                v-model="user.apodo"
                                label="Apodo"
                                autocomplete="off"
                                readonly
                                onfocus="this.removeAttribute('readonly');"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row> -->

                        <v-row>
                          <v-col>
                            <ValidationProvider ref="email" rules="required|email"
                                                v-slot="{ errors }">
                              <v-text-field
                                :error-messages="errors"
                                v-model="user.email"
                                label="E-mail"
                                prepend-inner-icon="fas fa-envelope"
                                autocomplete="off"
                                readonly
                                onfocus="this.removeAttribute('readonly');"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col>
                            <ValidationProvider ref="password" rules="min:4"
                                                v-slot="{ errors }">
                              <v-text-field
                                :error-messages="errors"
                                v-model="user.password"
                                label="Password"
                                :type="show1 ? 'text' : 'password'"
                                :append-icon="show1 ? 'fas fa-eye' : 'fas fa-eye-slash'"
                                @click:append="show1 = !show1"
                                autocomplete="off"
                                readonly
                                onfocus="this.removeAttribute('readonly');"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-card-text class="text-center">
                        <v-btn
                          color="warning"
                          elevation="0"
                          class="mr-4"
                          v-on:click="$router.push('/admin/users')"
                        >
                          Cancelar
                        </v-btn>
                        <v-btn
                          color="primary"
                          class="mr-4"
                          @click="submit"
                          :loading="status == 'loading'"
                        >
                          Guardar
                        </v-btn>
                        </v-card-text>
                      </v-col>
                    </v-row>

                  </v-form>
                </ValidationObserver>
              </v-card-text>
              <v-card-actions>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';

  export default {
    created() {
      const self = this;
      this.$store.dispatch('Authenticate/me').then(function (profile) {
        self.user.id = profile.id;
        self.user.name = profile.name;
       /*  self.user.apodo = profile.apodo; */
        self.user.email = profile.email;
      });
    },
    computed: {
      ...mapState({
        status: state => state.Users.status,
        roles: state => state.Users.roles,
      })
    },
    data() {
      return {
        show1: "",
        user: {
          id: '',
          name: '',
          /* apodo: '', */
          email: '',
          password: '',
        },
      }
    },
    methods: {
      async submit() {
        const self = this;

        let valid = await self.$refs.validator.validate();

        if (valid) {

          self.$store.dispatch('Users/update', self.user).then(function () {

            self.$store.dispatch('Authenticate/me');
            self.$router.push('/admin/users');

          }).catch(function (response) {
            for (var i in response.errors) {
              try {
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
        }
      }
    },
    components: {
      ValidationProvider,
      ValidationObserver,
    },
  }
  ;
</script>
